import { wetterService } from '../services/WetterService.js';
import { WMO_ICONS, WMO_FALLBACK } from '../util/wmoIcons.js';

// Morgens (8h) / Tags (13h) / Abends (18h) — fixe 3-Slot-Anordnung wie im Design-Handoff (§7.1 `.wx`).
const ZEITSLOTS = [
	{ stunde: 8, titel: 'Morgens' },
	{ stunde: 13, titel: 'Tags' },
	{ stunde: 18, titel: 'Abends' },
];

// Der Ortsname kommt von der Geocoding API und landet in einem title-Attribut
function escapeAttribut(text) {
	return text.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}

/**
 * Befüllt alle `[data-wetter-tag]` Platzhalter (die `.wx`-Spans in den Spaltenköpfen) mit den drei
 * Wetter-Icons des Tages. Wird bewusst fire-and-forget aufgerufen (nicht awaited) — der Grid-Aufbau
 * soll nie auf die Wetter-API warten. Ein Fehlschlag lässt die Platzhalter einfach leer, siehe
 * WetterService.js.
 */
async function fuelleWetterBadges() {
	const { ort, vorhersage } = await wetterService.getWetter();
	const ortPrefix = ort ? `${escapeAttribut(ort)} · ` : '';
	document.querySelectorAll('[data-wetter-tag]').forEach((badge) => {
		const datum = badge.getAttribute('data-wetter-tag');
		const tag = vorhersage[datum];
		if (!tag) {
			return; // Tag liegt außerhalb des Vorhersagezeitraums — Platzhalter bleibt leer
		}
		badge.innerHTML = ZEITSLOTS
			.filter(({ stunde }) => tag[stunde])
			.map(({ stunde, titel }) => {
				const { code, tempC } = tag[stunde];
				const info = WMO_ICONS[code] || WMO_FALLBACK;
				return `<span class="wxp" title="${ortPrefix}${titel}: ${info.label}, ${Math.round(tempC)}°C"><i class="bi ${info.icon}"></i>${Math.round(tempC)}°</span>`;
			})
			.join('');
	});
}

export { fuelleWetterBadges };
